import { parse, addHours } from "date-fns";

import { APPOINTMENT_COOKIE_NAME, type AppointmentCookie } from "@/lib/types/appointment-cookie";

export function writeAppointmentCookie({
  date,
  time,
  firstName,
}: {
  date: string | undefined;
  time: string | undefined;
  firstName: string;
}): void {
  if (!date || !time) return;

  const cookieValue: AppointmentCookie = {
    firstName,
    appointmentDate: date,
    appointmentTime: time,
  };

  const parsed = parse(`${date} ${time}`, "yyyy-MM-dd h:mm aa", new Date());
  const expiry = addHours(parsed, 8);
  const maxAge = Math.max(3600, Math.floor((expiry.getTime() - Date.now()) / 1000));

  const secureAttribute = globalThis.location?.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${APPOINTMENT_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(cookieValue))}; path=/; SameSite=Lax; max-age=${maxAge}${secureAttribute}`;
}
